import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLandingPagesDashboard_landingPagesDashboard as LandingPagesDashboard,
    GetLandingPagesDashboard as GetLandingPagesDashboardQuery,
    GetLandingPagesDashboardVariables as GetLandingPagesDashboardQueryVariables,
    DashboardInput,
} from 'nutshell-graphql-types';

import GET_LANDING_PAGES_DASHBOARD from '../queries/get-landing-pages-dashboard.graphql';

export const useGetLandingPagesDashboard = (
    input: DashboardInput
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    landingPagesDashboard: LandingPagesDashboard;
} => {
    const {loading, data, error} = useQuery<
        GetLandingPagesDashboardQuery,
        GetLandingPagesDashboardQueryVariables
    >(GET_LANDING_PAGES_DASHBOARD, {
        variables: {input},
        notifyOnNetworkStatusChange: true,
    });

    const {landingPagesDashboard} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        landingPagesDashboard,
    };
};
